import * as types from 'constants/ActionTypes';

const wayDefault = {
  originalSearchDate: null,
  dateSelected: null,
  interactionCount: 0,
  dateDelta: null,
  used: false,
};

const defaultState = {
  departure: { ...wayDefault },
  return: { ...wayDefault },
};

/**
 * carouselSession reducer.
 * Tracks carousel interactions per trip segment so they can be forwarded
 * to downstream purchase events (Purchase Attempt, Purchase Complete).
 *
 * @param {object} state - Current state.
 * @param {object} action - Dispatched action.
 * @returns {object} Next state.
 */
export default function carouselSession(state = defaultState, action) {
  switch (action.type) {
    case types.SET_CAROUSEL_SESSION: {
      const { way, payload } = action;
      const current = state[way];
      const originalSearchDate = current.originalSearchDate ?? payload.originalSearchDate;

      return {
        ...state,
        [way]: {
          ...current,
          originalSearchDate,
          dateSelected: payload.dateSelected ?? current.dateSelected,
          dateDelta: payload.dateDelta ?? current.dateDelta,
          interactionCount: current.interactionCount + 1 + (payload.pendingScrollCount ?? 0),
          used: true,
        },
      };
    }

    case types.RESET_SEARCH:
    case types.RESET_CAROUSEL_SESSION:
      return defaultState;

    default:
      return state;
  }
}
